<template>
  <div class="h-fill">
    <div class="pd-b-30" style="height:100%; background-image: linear-gradient(to bottom,#FA981F,#F3F3F3);">
      <div class="mg-l-20 mg-r-20 pd-t-15 pd-l-15 pd-r-15">
        <div class="display-flex pd-b-2 justify-content-space-between align-items-center"
             style="border-bottom: rgba(255,255,255,.2) solid 1px;">
          <div class="">
            <div v-if="isVip" class="justify-content-space-between align-items-center pd-b-10">
              <div class="c-f">
                <div class="fs-16">你已成为会员</div>
                <div class="fs-12">有效期至：{{ isForever ? '永久' : expireDay }}</div>
              </div>
            </div>
            <div v-else-if="$parent.loginUser" class="justify-content-space-between">
              <div class="c-f">
                <div class="fs-18">{{ $parent.loginUser.phone }}</div>
                <div class="fs-12">您暂未开通VIP会员服务</div>
              </div>
            </div>
            <div v-else class="justify-content-space-between pd-b-25"
                 style="border-bottom: rgba(255,255,255,.2) solid 1px;">
              <div class="c-f">
                <div class="fs-16">您尚未登录</div>
              </div>
            </div>
          </div>
          <div v-if="!$parent.appInner" class="c-f fs-12" @click="onChangeUserClick">切换帐号&gt;&gt;</div>
        </div>
      </div>
      <div class="pd-l-15 pd-r-15 pd-t-15 fs-12" v-if="!isForever">
        <div class="bg-f c-app-orange h-45 fs-18 justify-content-center align-items-center"
             style="border-radius: 10px 10px 0px 0px; border-bottom: 1px #eeeeee solid">
          <img src="static/images/vip_title_left.png" class="w-12"/>
          <div class="mg-l-5 mg-r-5">会员套餐</div>
          <img src="static/images/vip_title_right.png" class="w-12"/>
        </div>
        <div class="bg-f pd-t-10 pd-b-20" style="border-radius: 0px 0px 10px 10px;">
          <div v-if="pkg.length>1 && pkg[0].activityEndAt" class="fs-14 mg-t-5 c-app-orange text-align-center">
            {{ pkg[0].activityEndAt }}
          </div>
          <div style="overflow-x: scroll;">
            <div style="min-width: 350px;">
              <div class="display-flex text-align-center pd-t-10 pd-b-10 pd-l-10 pd-r-10">
                <div v-for="item,index in pkg"
                     style="min-width: 85px"
                     class="flex-1 border-3 bdr-10 shadow-2 align-items-center justify-content-center h-105 mg-l-5 mg-r-5 position-relative"
                     :class="index == selectPkg?'bdc-app-orange':'bdc-f'" @click="onPkgClick(index)">
                  <div class="column align-items-center">
                    <div class="c-app-orange fs-16 text-strong">
                      <span class="fs-22">{{ item.money }}元</span></div>
                    <div v-if="item.originMoney > 0">
                      <div v-if="item.originMoney > item.money" class=" text-delete c-9">
                        原价￥<span class="fs-12">{{ item.originMoney }}</span>
                      </div>
                      <div v-else class="c-9">
                        无优惠
                      </div>
                    </div>
                    <div>{{ item.desc }}</div>
                  </div>
                  <div v-if="item.desc2"
                       class="position-absolute t-0 fs-12 bg-app-orange c-f pd-2 pd-l-5 pd-r-5"
                       style="right: -3px;top:-3px;border-bottom-left-radius: 10px;border-top-right-radius: 10px"
                  >{{ item.desc2 }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fs-12 c-5 pd-l-20 pd-r-20 pd-t-10" v-if="this.hongbao.status == 1 && this.hongbao.countDown > 0">
            您已领取<span class="c-app-red mg-2">{{
              hongbao.amount / 100
            }}</span>元红包，购买【永久】或【年度】会员时可在优惠价格基础上叠加抵扣，红包剩余有效期<span
              class="c-app-red  mg-2">{{
              formatCountdown
            }}</span>
          </div>
          <div class="fs-12 c-6 mg-t-15">
            <div class="text-align-center pd-l-10 pd-r-10">
              请阅读
              <a href="https://memo93.com/server/index/vipagreement.html"
                 class="c-app-orange cursor-pointer">《会员服务协议》</a>
              和
              <a href="https://memo93.com/anymo/privacy" class="c-app-orange cursor-pointer">《隐私政策》</a>
              购买即为同意协议
              <template v-if="$parent.isIos">，按年/按季到期自动续费可随时在系统设置取消</template>
            </div>
          </div>
        </div>
      </div>
      <div class="pd-l-15 pd-r-15 pd-b-250">
        <div class="c-f h-40 fs-18 justify-content-center align-items-center pd-t-4">
          <img src="static/images/vip_title_left.png" class="w-12"/>
          <div class="mg-l-5 mg-r-5">会员权益说明</div>
          <img src="static/images/vip_title_right.png" class="w-12"/>
        </div>
        <div class="bg-f pd-l-10 pd-r-10 pd-t-20 pd-b-20" style="border-radius: 10px 10px 10px 10px;">
          <div class="display-flex text-align-center">
            <div class="fs-16 flex-3" style="font-weight: 500;">权益介绍</div>
            <div class="fs-16 flex-2" style="font-weight: 500;">普通用户</div>
            <div class="fs-16 flex-2 c-app-orange" style="font-weight: 500;">会员用户</div>
          </div>
          <div class="mg-t-25 display-flex text-align-center align-items-center">
            <div class="flex-3">
              <div class="fs-18" style="font-weight: 500;">
                云同步数据
              </div>
              <div class="fs-12 c-6">
                多设备数据同步、云端备份
              </div>
            </div>
            <div class="fs-14 flex-2"><img src="static/images/cross.png" class="w-12"></div>
            <div class="fs-14 flex-2"><img src="static/images/tick.png" class="w-20"></div>
          </div>
          <div class="mg-t-25 display-flex text-align-center align-items-center">
            <div class="flex-3">
              <div class="fs-18" style="font-weight: 500;">
                刷题练习
              </div>
              <div class="fs-12 c-6">
                自定义筛选卡片巩固练习
              </div>
            </div>
            <div class="fs-14 flex-2"><img src="static/images/cross.png" class="w-12"></div>
            <div class="fs-14 flex-2"><img src="static/images/tick.png" class="w-20"></div>
          </div>
          <div class="mg-t-25 display-flex text-align-center align-items-center">
            <div class="flex-3">
              <div class="fs-18" style="font-weight: 500;">
                朗读卡片
              </div>
              <div class="fs-12 c-6">
                将文字转语音朗读<br>支持单卡、多卡自动朗读
              </div>
            </div>
            <div class="fs-14 flex-2"><img src="static/images/cross.png" class="w-12"></div>
            <div class="fs-14 flex-2"><img src="static/images/tick.png" class="w-20"></div>
          </div>
          <div class="mg-t-25 display-flex text-align-center align-items-center">
            <div class="flex-3">
              <div class="fs-18" style="font-weight: 500;">
                卡片数量限制
              </div>
              <div class="fs-12 c-6">
                超过后仅限新增自制卡片
                <div class="text-strong">不限制购买导入卡片</div>
              </div>
            </div>
            <div class="fs-14 flex-2">
              3000张
            </div>
            <div class="fs-14 flex-2 c-app-orange">无限制</div>
          </div>
          <div class="mg-t-25 display-flex text-align-center align-items-center">
            <div class="flex-3">
              <div class="fs-18" style="font-weight: 500;">
                卡片模板
              </div>
              <div class="fs-12 c-6">
                可以使用的官方模板
              </div>
            </div>
            <div class="fs-14 flex-2"> 问答题 / 填空题</div>
            <div class="fs-14 flex-2 c-app-orange">无限制</div>
          </div>
          <div class="mg-t-20 c-9 text-align-center fs-12">更多适用会员的功能正在开发中，敬请期待...</div>
        </div>
      </div>
      <div class="position-fixed z-index-99 b-0 w-fill" v-if="!isForever">
        <div @click="onBuyClick"
             class="mg-l-20 mg-r-20 mg-t-6 mg-b-6 pd-10 bg-app-orange c-f text-align-center lh-30 fs-18 bdr-25">
          {{ isVip ? '续费会员' : '开通会员' }}
        </div>
        <div v-if="$parent.isIos" class="mg-b-20">

        </div>
      </div>

    </div>

    <van-dialog v-model="showPayResult" title="支付提示" show-cancel-button confirmButtonText="已支付"
                cancelButtonText="未支付" @confirm="onPayConfirm" @cancel="onPayCancel">
      <div class="mg-20">
        <div class="text-align-center">是否已支付完成？</div>
        <div v-if="$parent.appInner && copyPayUrl" class="c-app-orange fs-14 mg-t-20">调起支付中，若无反应请使用手机浏览器支付，<span
            class="c-app-blue"
            @click="onCopyPayUrlClick">点我复制链接</span>
        </div>
      </div>
    </van-dialog>
    <van-dialog v-model="showHongbao" :title="inWechat?'会员优惠红包':'新用户1～20元随机红包'">
      <div class="mg-20 text-align-center">
        <img src="/h5/static/images/hongbao.png" class="w-80"/>
        <div>您已获得<span class="c-app-red text-align-center mg-10 fs-20">{{ hongbao.amount / 100 }}</span>元红包</div>
        <div class="mg-t-20 fs-12" v-if="inWechat">在当前页面支付时抵扣，红包有效期：</div>
        <div v-else>
          <div class="mg-t-20 fs-12"></div>
          <div class="mg-t-20 fs-12">仅限购买【永久会员】和【年度会员】时抵扣<br>需使用支付宝支付</div>
          <div class="mg-t-20 fs-12">红包有效期：</div>
        </div>
        <div class="c-app-orange mg-t-10">{{ formatCountdown }}</div>
      </div>
    </van-dialog>

    <van-action-sheet
        v-model="showPayOptions"
        cancel-text="取消"
        close-on-click-action>
      <div class="bg-f pd-20 fs-18">
        <div class="c-a fs-14  mg-b-30 display-flex justify-content-space-between align-items-center">
          <div class="flex-1"></div>
          <div class="text-align-center flex-2">选择支付方式</div>
          <div class="fs-10 flex-1 c-app-red text-align-right" @click="openHongbao"><span
              v-if="!isVip && hongbao.status == 0">领取优惠红包</span>
          </div>
        </div>
        <div class="fs-12 text-align-center mg-b-20" v-if="canUseHongbao">
          已领取<span class="c-app-red mg-2">{{ hongbao.amount / 100 }}</span>元红包使用<b>支付宝</b>可抵扣,<span
            class="c-app-red  mg-2">{{
            formatCountdown
          }}</span>失效
        </div>
        <div @click="onPaySelectClick('alipay_h5')" class="justify-content-center align-items-center pd-10">
          <img src="/h5/static/images/alipay.png" class="w-20">
          <div class="w-120 text-align-center">支付宝</div>
          <p class="fs-9" v-if="canUseHongbao && morePayWay">可使用红包</p>
        </div>

        <div class="h-1 bg-f3f mg-t-15 mg-b-10"></div>
        <div v-if="!morePayWay" @click="morePayWay = true"
             class="justify-content-center align-items-center pd-10 mg-t-10">
          <div class="w-200 text-align-center c-6 fs-12">其他支付方式&gt;&gt;</div>
        </div>
        <template v-else>
          <div @click="onPaySelectClick('wechat')" class="justify-content-center align-items-center pd-10 mg-t-10">
            <img src="/h5/static/images/wechatpay.png" class="w-20">
            <div class="w-120 text-align-center">微信支付</div>
            <p class="fs-9" v-if="canUseHongbao">不支持红包</p>
          </div>
        </template>
      </div>
    </van-action-sheet>
    <div v-if="(!$parent.appInner || !$parent.isIos) && !isForever && (hongbao.status === 0 || hongbao.status === 1)"
         class="position-fixed b-70 r-25"
         @click="openHongbao">
      <img src="/h5/static/images/hongbao.png" class="w-50 bdr-5 rotate-shake">
      <div class="fs-10 text-align-center c-app-red text-strong">
        <span v-if="hongbao.status == 0">领取红包</span>
        <span v-else>查看红包</span>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../libs/api.request'
import util from '../libs/util'

export default {
  name: "vip",
  data() {
    return {
      morePayWay: true,
      pkg: [],
      isVip: false,
      copyPayUrl: '',
      expireDay: '',
      selectPkg: 0,
      showPayResult: false,
      showPayOptions: false,
      showHongbao: false,
      ordering: false,
      remark: '',
      isForever: false,
      from: this.$route.query.from,
      channel: this.$route.query.chan,
      hongbao: {
        amount: 0,
        status: -1,// -1 没有红包，0待打开，1已打开，2已使用
        countDown: 0,
      },
      inWechat: false
    }
  },
  computed: {
    canUseHongbao() {
      return this.hongbao.status == 1 && this.hongbao.countDown > 0 && this.pkg[this.selectPkg].id !== 1
    },
    formatCountdown() {
      const hours = Math.floor(this.hongbao.countDown / 3600); // 获取小时数
      const minutes = Math.floor((this.hongbao.countDown % 3600) / 60); // 获取剩余分钟数
      const seconds = this.hongbao.countDown % 60; // 获取剩余秒数
      let result = '';
      if (hours > 0) {
        result += `${String(hours).padStart(2, '0')}小时`;
      }
      result += `${String(minutes).padStart(2, '0')}分${String(seconds).padStart(2, '0')}秒`;

      return result;
    }
  },
  methods: {
    onPaySelectClick(payType) {
      if (this.ordering) {
        return;
      }

      this.ordering = true;
      this.$toast.loading({loadingType: 'spinner', message: '下单中', duration: 8000, overlay: true});
      request.request({
        url: 'user/vipOrder',
        data: {
          id: this.pkg[this.selectPkg].id,
          returnUrl: location.href,
          payType: payType,
          remark: this.remark,
          channel: this.channel,
          platform: 3,
          useHongbao: this.hongbao.status === 1 ? 1 : 0,
          wxOpenId: this.$parent.wxOpenId
        },
        method: 'post'
      }).then((data) => {
        this.$toast.clear();
        this.ordering = false;
        if (this.inWechat) {
          WeixinJSBridge.invoke('getBrandWCPayRequest', data.payData, (res) => {
            if (res.err_msg === "get_brand_wcpay_request:ok") {
              this.showPayOptions = false;
              this.$toast.loading({
                loadingType: 'spinner',
                message: '正在查询支付结果',
                duration: 60000,
                overlay: true
              });
              sessionStorage.setItem("checkVipOrder", 1);
              setTimeout(() => {
                location.reload();
              }, 3000);
            }
          });
        } else {
          this.copyPayUrl = data.copyPayUrl;
          setTimeout(() => {
            this.showPayResult = true;
            this.showPayOptions = false;
          }, 800);
          location.assign(data.payUrl);
        }
      }).catch((err) => {
        this.$toast.clear();
        this.ordering = false;
        this.$toast(err.message)
      })
    },
    onPayConfirm() {
      let href = location.href;
      this.$toast.loading({loadingType: 'spinner', message: '', duration: 8000, overlay: true});
      setTimeout(() => {
        location.replace(href.replace(new RegExp("h5pay_redirect=", "gm"), 'h5pay_redirected='));
      }, 1500);
    },
    onPayCancel() {
      let href = location.href;
      location.replace(href.replace(new RegExp("h5pay_redirect=", "gm"), 'h5pay_redirected='));
    },
    onCopyPayUrlClick() {
      this.$parent.execCopy(this.copyPayUrl, '链接已复制请前往手机浏览器粘贴支付');
    },
    onPkgClick(index) {
      this.selectPkg = index;
    },
    onBuyClick() {
      if (!this.$parent.loginUser) {
        this.$parent.login();
        return;
      }

      if (this.inWechat) {
        this.onPaySelectClick('wechat_gzh');
        return;
      }

      if (this.$parent.isIos) {
        buyVip.postMessage(JSON.stringify({skuId: this.pkg[this.selectPkg].id}));
        return;
      }

      this.showPayOptions = true;
    },
    openHongbao() {
      if (this.hongbao.status === 0) {
        this.$toast.loading({loadingType: 'spinner', message: '正在打开红包', duration: 60000, overlay: true});
        request.request({
          url: 'user/openHongbao',
          params: {
            inWechat: this.inWechat ? 1 : 0
          }
        }).then(data => {
          this.$toast.clear();
          this.hongbao = data;
          this.showHongbao = true;
        }).catch((err) => {
          this.$toast.clear();
          this.$toast(err);
        })
      } else {
        this.showHongbao = true;
      }
    },
    onChangeUserClick() {
      this.$parent.login();
    }
  },
  mounted() {
    this.inWechat = util.inWechat();
    window.scrollTo({top: 0});
    if (this.$parent.authToken) {
      this.$toast.loading({loadingType: 'spinner', message: '', duration: 60000, overlay: true});
      request.request({
        url: 'user/vipInfo',
        params: {
          appVersion: this.$parent.appVersion,
          ios: this.$parent.isIos ? 1 : 0,
          appInner: this.$parent.appInner ? 1 : 0,
          anymo: 1,
          inWechat: this.inWechat ? 1 : 0
        }
      }).then(data => {
        this.$toast.clear();
        this.pkg = data.pkg;
        this.isVip = data.isVip;
        if (!this.isVip) {
          if (sessionStorage.getItem("checkVipOrder")) {
            sessionStorage.removeItem("checkVipOrder");
            this.$dialog.alert({message: "如果您已支付但是仍然不是会员状态，请尝试刷新页面查"});
          }
        }

        this.expireDay = data.expireDay;
        this.isForever = data.isForever;
        if (!this.isForever) {
          if (data.hongbao) {
            this.hongbao = data.hongbao;
          } else {
            this.hongbao = {
              amount: 0,
              status: 0,
              countDown: 0,
            }

            if (this.inWechat) {
              this.openHongbao();
            }
          }
        }
      }).catch((err, code) => {
        this.$toast.clear();
        this.$toast(err);
        if (err.code > 400 && err.code < 403) {
          this.$parent.login();
        }
      });
    } else {
      // 未登录
      if (!this.inWechat) {
        this.$parent.login();
      } else {
        if (!this.$parent.wxOpenId) {
          // wxOpenId 说明正在跳转微信登录
        } else {
          this.$parent.login();
        }
      }
    }


    if (this.$route.query['h5pay_redirect'] === 'yes') {
      setTimeout(() => {
        this.showPayResult = true;
      }, 100)
    }

    setInterval(() => {
      if (this.hongbao.countDown > 0) {
        this.hongbao.countDown -= 1;
      }
    }, 1000);
  }
}
</script>

<style scoped>
.rotate-shake {
  display: inline-block;
  animation: rotateShake 3.5s infinite ease-in-out;
  transform-origin: center;
}

@keyframes rotateShake {
  0%, 100% {
    transform: rotate(0deg);
  }
  10%, 20%, 30% {
    transform: rotate(-20deg);
  }
  15%, 25%, 35% {
    transform: rotate(20deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }

}
</style>
